import React from 'react';
import { CartesianGrid, ResponsiveContainer, Scatter, ScatterChart, XAxis, YAxis, Tooltip, Legend, LineChart, Line } from 'recharts';

function HistoryChart({ data }) {
    // const sortedData = [...data].sort((a, b) => a.count - b.count);
    const sortedData = [...data].sort((a, b) => a.sId_0 - b.sId_0);
    const ticksArr = sortedData.map(el => el.count);
    const colorArr = ["#0A2B83", "#45BFCE", "#2CB6B3", "#0070C0", "#0F9ED5"];
    const domain = sortedData.length > 0 ? [sortedData[0]["count"], sortedData[sortedData.length - 1]["count"]] : [0, 10];
    const labelMap = {
        data_0_0: "YS",
        data_0_1: "UTS",
        data_1_0: "피크",
        data_2_1: "좌1",
        data_2_3: "우1"
    }
    return (
        <ResponsiveContainer>
            <LineChart
                data={sortedData}
                // padding={{ left: 20, right: 20 }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <YAxis
                    // ticks={data.length > 0 ? null : [0, 10, 20, 30, 40, 50]}
                    // domain={data.length > 0 ? null : [0, 50]}
                    // width={34}
                    tickMargin={6}
                    // tickSize={8}
                    tick={{ fontSize: 12 }}
                />
                <XAxis
                    // type='category'
                    // dataKey={"count"}
                    dataKey="count"
                    height={14}
                    domain={domain}
                    // interval={data[0]?.count >= 100 ? 1 : 0}
                    // interval={0}
                    // tick={({ x, y, payload, index }) => {
                    //     const total = data.length;
                    //     const showTick = (
                    //         data[data.length - 1]?.count < 100 ||
                    //         (total % 2 === 1 && index % 2 === 0) || // 홀수 개면 0,2,4,...
                    //         (total % 2 === 0 && index % 2 === 1) || // 짝수 개면 1,3,5,...
                    //         index === total - 1 // 마지막은 무조건 표시
                    //     );

                    //     return showTick ? (
                    //         <text x={x} y={y + 10} textAnchor="middle" fill="#666" fontSize={12}>
                    //             {payload.value}
                    //         </text>
                    //     ) : null;
                    // }}
                    // interval={Math.floor(data.length / 10)}
                    tick={{ fontSize: 12 }}
                    tickLine={false}
                    // ticks={data.length > 0 ? ticksArr : [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}
                    tickFormatter={(val) => val.toString()}
                    // rotate={45}
                    minTickGap={17}
                />

                <Tooltip
                content={({ active, payload, label, coordinate }) => {
                    if (!active || !payload || !payload.length) return null;

                    // 마우스 기준 위치
                    const wrapperStyle = {
                    position: "absolute",
                    left: coordinate.x + 10,   // 마우스 오른쪽으로 10px
                    top: coordinate.y + 10,    // 마우스 아래로 10px
                    pointerEvents: "none",
                    //   fontSize: 12,
                    };

                    // 실제 툴팁 박스 스타일 (다른 툴팁이랑 통일)
                    const boxStyle = {
                    background: "white",
                    borderRadius: "10px",
                    border: "none",
                    boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.3)",
                    padding: "6px 8px",
                    whiteSpace: "nowrap",
                    //   fontSize: 12,
                    };

                    return (
                    <div style={wrapperStyle}>
                        <div style={boxStyle}>
                        {/* label 부분 (X축 값) */}
                        <div style={{ marginBottom: 4 }}>
                            {/* 예: 카운트: 123 */}
                            {label}
                        </div>

                        {/* 라인별 값 */}
                        {payload.map((p) => {
                            const name = labelMap[p.name] || p.name;
                            const color = p.color || p.stroke || "#0F9ED5"; // 라인 색상 사용

                            return (
                            <div key={p.name}>
                                <span style={{ color }}>
                                {name}: {p.value}
                                </span>
                            </div>
                            );
                        })}
                        </div>
                    </div>
                    );
                }}
                />
                      
                {
                    data.length > 0 ?
                        Object.keys(data[data.length - 1])
                            .filter(key => key.startsWith('data_')) // data_로 시작하는 키만 사용
                            .map((key, idx) => {
                                return (
                                    // <Scatter
                                    //     key={`scatt_${idx}`}
                                    <Line
                                        key={`line_${idx}`}
                                        type="monotone"
                                        dataKey={key}
                                        // fill={colorArr[idx]}
                                        stroke={colorArr[idx % colorArr.length]}
                                        dot={false}
                                        strokeWidth={2}
                                    />
                                )
                            })
                        : null
                }

            </LineChart>
        </ResponsiveContainer>
    );
}

export default HistoryChart;
